import React, { Component } from 'react';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import Overlay from 'ol/Overlay.js';
import * as proj from 'ol/proj';
import 'ol/ol.css';
import {
  defaults as defaultInteractions,
  DragRotateAndZoom,
} from 'ol/interaction';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Location from '@material-ui/icons/Room';
import { Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';

const baghdad = proj.fromLonLat([44.3661, 33.3152]);

export default class OlMap extends Component {
  constructor(props) {
    super(props);
    this.popupRef = React.createRef();
    this.state = { center: baghdad, zoom: 6 };

    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),

      target: null,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],

      view: new View({
        center: this.state.center,
        zoom: this.state.zoom,
        minZoom: 6,
      }),
    });
  }

  componentDidMount() {
    this.map.setTarget('map');
    // Listen to map changes
    this.map.on('moveend', () => {
      let center = this.map.getView().getCenter();
      let zoom = this.map.getView().getZoom();
      this.setState({ center, zoom });
    });

    this.popup = new Overlay({
      element: this.popupRef.current,
    });
    this.map.on('click', (evt) => {
      this.popup.setPosition(evt.coordinate);
      this.map.addOverlay(this.popup);
      this.props.passLocation(
        proj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326')
      );

      this.map.getView().setCenter(evt.coordinate);
    });
    const vectorL = new VectorLayer({
      source: new VectorSource(),
    });
    this.map.addLayer(vectorL);
  }

  componentWillUnmount() {
    this.map.setTarget(null);
  }
  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const newLoc = proj.fromLonLat([
          position.coords.longitude,
          position.coords.latitude,
        ]);
        this.popup.setPosition(newLoc);
        this.map.addOverlay(this.popup);
        this.props.passLocation(
          proj.transform(newLoc, 'EPSG:3857', 'EPSG:4326')
        );

        this.map.getView().setCenter(newLoc);
        this.map.getView().setZoom(8);
      });
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  };

  render() {
    return (
      <div>
        <div dir='rtl' className='m-1'>
          <button
            type='button'
            onClick={this.getLocation}
            className='text-black courser-pointer flex focus:outline-none mx-2 '
          >
            حدد موقعك الحالي
            <div className='n-blue mr-1'>بالضغط هنا </div>
          </button>
        </div>

        <div id='map' style={{ width: '100%', height: '360px' }} />
        <div className='blue-circle' id='overlay' title='overlay'></div>
        <div
          className='blue-circle'
          id='popup'
          title='Welcome to OpenLayers'
          ref={this.popupRef}
        >
          <Location alt='lovSvg' />
        </div>
      </div>
    );
  }
}
